export const calculateUploadSpeed = (
  loaded: number,
  lastLoaded: number,
  timeElapsed: number
): { speedBps: number; speedText: string } => {
  const bytesUploaded = loaded - lastLoaded;
  const speedBps = bytesUploaded / timeElapsed;
  
  // แปลงเป็นหน่วยที่เหมาะสม (KB/s, MB/s)
  let speedText = '';
  if (speedBps >= 1024 * 1024) {
    speedText = `${(speedBps / (1024 * 1024)).toFixed(2)} MB/s`;
  } else if (speedBps >= 1024) {
    speedText = `${(speedBps / 1024).toFixed(2)} KB/s`;
  } else {
    speedText = `${Math.round(speedBps)} B/s`;
  }
  
  return { speedBps, speedText };
}; 